import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { useSelector, useDispatch } from 'react-redux'
import { createFundraiserAccount } from 'actions/fundraiserAccounts'
import { Redirect } from 'react-router-dom'

export default function StripeConnectRedirect() {
  const { location: { search }  } = useHistory()
  const dispatch = useDispatch()
  const { user: { id: userId }, userSession: { state: userSessionState, referrer } } = useSelector(({ auth }) => auth)

  useEffect(() => {
    const { code: stripeAuthorizationCode, state } = queryString.parse(search)

    if (stripeAuthorizationCode && state === userSessionState) {
      dispatch(createFundraiserAccount(userId, stripeAuthorizationCode))
    }


  }, [search, userId, dispatch, userSessionState])

  return <Redirect to={referrer} />
}
